import React, {Fragment} from 'react'
import Card from '../../components/Card'

const step1 = require("../../assets/icons/ui/Step1.svg")
const step2 = require("../../assets/icons/ui/Step2.svg")
const step3 = require("../../assets/icons/ui/Step3.svg")

const Instruction = () =>{
  return (
    <Fragment >
      <div className="instrction_mainDiv" data-test="instructionComponent">
        <h1 className="report-outage__title">Report a Street Light Outage</h1>
        <Card className="instruction_card">
          <div>
            <span className="instrction_subFont">Follow the steps below to report an outage:</span>
            <div className="instrction_itemDiv">
              <div className="instrction_innerDiv" data-test="instructionContent">
                <span className="instrction_svg">
                  <img src={step1} alt="Step-1" />
                </span>
                <div>
                  <div className="instrction_content">
                  Enter the address or nearest cross-street closest to the streetlight location or zoom (+) into a location on the map.
                  </div>
                </div>
              </div>
              <div className="instrction_innerDiv" >
                <span className="instrction_svg2">
                  <img src={step2} alt="Step-2" />
                </span>
                <div>
                  <div className="instrction_content2">
                  Click on the correct streetlight located on the map.
                  </div>
                </div>
              </div>
              <div className="instrction_innerDiv" >
                <span className="instrction_svg">
                  <img src={step3} alt="Step-3" />
                </span>
                <div>
                  <div className="instrction_content">
                  After completing and submitting the form, you will receive confirmation and a reference number.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </Fragment>
  )
}
export default Instruction
